// 9fbef606107a605d69c0edbcd8029e5d 
const TOAST_CONSTANTS = {
  TOAST_MESSAGE_INFO: 'TOAST_MESSAGE_INFO',
  TOAST_MESSAGE_RESET: 'TOAST_MESSAGE_RESET',
  TOAST_MESSAGE_POSITION: 'TOAST_MESSAGE_POSITION',
};

export default TOAST_CONSTANTS;
